module.exports = __webpack_public_path__ + "assets/img/1810.2cefb3a3.png";